import { FormDiscriminatedProps } from '@App/forms/common/form-field'
import { DropdownDiscriminatedProps } from '@App/forms/common/dropdown-form-field'
import { SelectOption } from '@Components/Selectors/Select'
import { MAX_LENGTH_MESSAGE, REQUIRED_MESSAGE } from '@Const/error-messages'
import { FormFieldTypes } from '@App/enum/form-field-types'

export const getDefaultStreetAddress = (prefix: string, optional: boolean): FormDiscriminatedProps => ({
    type: FormFieldTypes.TEXT,
    name: prefix + 'streetAddress',
    label: 'Street Address',
    registerOptions: {
        required: optional ? false : REQUIRED_MESSAGE,
        maxLength: { value: 60, message: `${MAX_LENGTH_MESSAGE} 60` },
    },
})

export const getDefaultUnitNumber = (prefix: string): FormDiscriminatedProps => ({
    type: FormFieldTypes.TEXT,
    name: prefix + 'unitNumber',
    label: 'Unit Number',
    registerOptions: {
        required: false,
        maxLength: { value: 10, message: `${MAX_LENGTH_MESSAGE} 10` },
    },
})

export const getDefaultAttention = (prefix: string): FormDiscriminatedProps => ({
    type: FormFieldTypes.TEXT,
    name: prefix + 'attention',
    label: 'Attention',
    registerOptions: {
        required: false,
        maxLength: { value: 25, message: `${MAX_LENGTH_MESSAGE} 25` },
    },
})

export const getDefaultCity = (prefix: string, optional: boolean): FormDiscriminatedProps => ({
    type: FormFieldTypes.TEXT,
    name: prefix + 'city',
    label: 'City / Town',
    registerOptions: {
        required: optional ? false : REQUIRED_MESSAGE,
        maxLength: { value: 60, message: `${MAX_LENGTH_MESSAGE} 60` },
    },
})

export const getDefaultState = (
    prefix: string,
    stateOptions: SelectOption[],
    isUSAOrCan: boolean
): DropdownDiscriminatedProps | FormDiscriminatedProps => {
    if (isUSAOrCan) {
        return {
            type: FormFieldTypes.DROPDOWN,
            name: prefix + 'state',
            label: 'State / Province',
            options: stateOptions,
            isClearable: true,
            registerOptions: { required: REQUIRED_MESSAGE },
        }
    } else {
        return {
            type: FormFieldTypes.TEXT,
            name: prefix + 'state',
            label: 'State / Province',
            registerOptions: {
                required: false,
                maxLength: { value: 60, message: `${MAX_LENGTH_MESSAGE} 60` },
            },
        }
    }
}

export const getDefaultPostalCode = (prefix: string, isPostalCodeRequired: boolean): FormDiscriminatedProps => ({
    type: FormFieldTypes.TEXT,
    name: prefix + 'postalCode',
    label: 'ZIP / Postal Code',
    registerOptions: {
        required: isPostalCodeRequired ? REQUIRED_MESSAGE : false,
        maxLength: { value: 60, message: `${MAX_LENGTH_MESSAGE} 60` },
    },
})
